import type {
  PcmpRequestCounts,
  PcmpRequestStatus,
  PcmpRequestView,
} from '../types/pcmpRequest.types';
import type { PcmpRequestAppliesTo } from '../types/pcmpRequestCategory.types';

export const PCMP_REQUEST_APPLIES_TO_LABELS = {
  STANDARD: 'Standard',
  DISBURSED: 'Disbursed',
} as const satisfies Record<PcmpRequestAppliesTo, string>;

/** Select item for a category with no action: approving only records the decision. */
export const PCMP_NO_ACTION_PLAN_LABEL = 'None (record the decision only)';

/** The category that takes a payment back (legacy CATEGORY_PAYMENT_RETURN, LDS-765). */
export const PCMP_RETURN_CATEGORY_CODE = 'PAYMENT_RETURN';

/** The Requested tab of Accounts Payment Return requests, the ones Accounts staff work (LDS-805). */
export const PCMP_ACCOUNTS_RETURN_REQUESTS_TAB = `${PCMP_RETURN_CATEGORY_CODE}:ACCOUNTS`;

export const PCMP_REQUEST_DEFAULT_VIEW: PcmpRequestView = 'STANDARD';

export const PCMP_REQUEST_VIEW_LABELS = {
  STANDARD: 'Standard',
  DISBURSED: 'Disbursed',
  MINE: 'My Requests',
  BATCHES: 'Batches',
  URGENT_REQUESTS: 'Urgent Requests',
} as const satisfies Record<PcmpRequestView, string>;

/** The badge of each tab, from the counts endpoint. */
export const PCMP_REQUEST_VIEW_COUNT = {
  STANDARD: (counts) => counts.standard,
  DISBURSED: (counts) => counts.disbursed,
  MINE: (counts) => counts.mine,
  BATCHES: (counts) => counts.batches,
  URGENT_REQUESTS: (counts) => counts.urgentRequests,
} as const satisfies Record<PcmpRequestView, (counts: PcmpRequestCounts) => number>;

export const PCMP_REQUEST_EMPTY_MESSAGE = {
  STANDARD: 'No proposals can be requested right now',
  DISBURSED: 'No disbursed proposals can be requested right now',
  MINE: 'You have not raised any request',
  BATCHES: 'No urgent batches found',
  URGENT_REQUESTS: 'You have not raised any Urgent Payment request',
} as const satisfies Record<PcmpRequestView, string>;

export const PCMP_REQUEST_STATUS_LABELS = {
  PENDING: 'Pending',
  PROCESSING: 'Processing',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
} as const satisfies Record<PcmpRequestStatus, string>;

export const PCMP_REQUEST_STATUS_TONE = {
  PENDING: 'warning',
  PROCESSING: 'info',
  APPROVED: 'success',
  REJECTED: 'danger',
} as const satisfies Record<PcmpRequestStatus, 'success' | 'warning' | 'info' | 'danger'>;
